/*
 * VueJS Router paths
 */

module.exports = ( Vue ) => { 
  
    var routes = [

        //Landing page route 
        { 
            path: '/', 
            name : 'index', 

            component: require('./components/Dashboard.vue').default

        },

        //User profile pages
        { 
            path: '/profile/:page?', 
            name : 'profile', 

            component: require('./components/Users/Index.vue').default

        },

        //Block all other routes 404
        { 
            path : '/*', 
            name : '404', 
            component: require('./components/ErrorPages/404.vue').default
        }
    ]

    return routes;
}
